import { z } from 'zod';

/**
 * Zod schema for item schedule.
 *
 * Contains scheduling information for an item.
 * Timestamps are in milliseconds.
 */
export const itemScheduleSchema = z.object({
  itemId: z.number().int().positive(),
  expectedStart: z.number().int().optional(),
  expectedFinish: z.number().int().optional(),
  latestFinish: z.number().int().optional(),
});

export type ItemScheduleDTO = z.infer<typeof itemScheduleSchema>;
